import React, { Dispatch, SetStateAction, useContext, useState, useEffect } from 'react';
import InsightFiltersViewModel from '../../ViewModels/InsightFiltersViewModel';
import SelectFilterContainer from '../GenericFilters/Select/SelectFilterContainer';
import { APIContext } from "../../../Contexts/APIContext";
import { InsightView } from '../../../ViewModels/InsightView';

interface IInsightNameFilterContainerProps {
    view: InsightView
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
}

export default function InsightNameFilterContainer({ view, filters, setFilters }: IInsightNameFilterContainerProps) {
    const { get } = useContext(APIContext);
    const [insightNames, setInsightNames] = useState<string[]>([]);

    useEffect(() => {
        let controllerAction: string;
        switch (view) {
            case InsightView.Agent:
                controllerAction = 'GetAgentInsightNames';
                break;
            case InsightView.Customer:
                controllerAction = 'GetCustomerInsightNames';
                break;
            case InsightView.Operational:
                controllerAction = 'GetOperationalInsightNames';
                break;
            default:
                throw new Error('Unknown InsightView');
        }
        get('Insight', `${controllerAction}?client=${filters.client}`, (data) => setInsightNames(data))
    }, [view, filters.client])

    return (
        <>
            <SelectFilterContainer
                filters={filters}
                setFilters={setFilters}
                name={'insightName'}
                label={'Insight Name'}
                options={insightNames} />
        </>
    );
};
